export const DEFAULT_COMPANY_NAME = 'your company';
const COMPANY_NAME_PLACEHOLDER_PATTERN = /{{\s*company(?:_|\s*)name\s*}}|\[company name\]/gi;

export type CompanyNameContext = {
  lead?: {
    company?: string | null;
  } | null;
  user?: {
    companyName?: string | null;
  } | null;
  settings?: {
    companyName?: string | null;
  } | null;
  companyName?: string | null;
};

export function normalizeCompanyName(value: unknown) {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().replace(/\s+/g, ' ');
  return normalized.length > 0 ? normalized : null;
}

export function resolveWorkspaceCompanyName(...candidates: unknown[]) {
  for (const candidate of candidates) {
    const normalized = normalizeCompanyName(candidate);
    if (normalized) {
      return normalized;
    }
  }

  return DEFAULT_COMPANY_NAME;
}

export function resolveCompanyName(
  context?: CompanyNameContext | null,
  fallback = DEFAULT_COMPANY_NAME
) {
  const leadCompanyName = normalizeCompanyName(context?.lead?.company);
  if (leadCompanyName) {
    return leadCompanyName;
  }

  return resolveWorkspaceCompanyName(
    context?.user?.companyName,
    context?.settings?.companyName,
    context?.companyName,
    fallback
  );
}

export function replaceCompanyNamePlaceholders(value: string, companyName?: unknown) {
  return value.replace(COMPANY_NAME_PLACEHOLDER_PATTERN, resolveWorkspaceCompanyName(companyName));
}
